"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

var _Markdown = require("./Markdown");

var _Markdown2 = _interopRequireDefault(_Markdown);

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarTitlebox = function SidebarTitlebox(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      _ref$Markdown = _ref.Markdown,
      Markdown = _ref$Markdown === undefined ? _Markdown2.default : _ref$Markdown,
      _ref$Timestamp = _ref.Timestamp,
      Timestamp = _ref$Timestamp === undefined ? function (_ref2) {
    var created_utc = _ref2.created_utc;
    return created_utc;
  } : _ref$Timestamp,
      _ref$siteprefix = _ref.siteprefix,
      siteprefix = _ref$siteprefix === undefined ? "r" : _ref$siteprefix,
      subreddit = _ref.subreddit,
      description = _ref.description,
      description_html = _ref.description_html,
      useStyle = _ref.useStyle,
      subscribers = _ref.subscribers,
      accounts_active_is_fuzzed = _ref.accounts_active_is_fuzzed,
      accounts_active = _ref.accounts_active,
      created_by = _ref.created_by,
      created_utc = _ref.created_utc,
      data = _ref.subredditData,
      isShowingCustomStyleOption = _ref.isShowingCustomStyleOption,
      setStyleEnabled = _ref.setStyleEnabled,
      setStyleDisabled = _ref.setStyleDisabled,
      onSubscribe = _ref.onSubscribe,
      onUnsubscribe = _ref.onUnsubscribe;
  return _react2.default.createElement(
    "div",
    { className: "spacer" },
    _react2.default.createElement(
      "div",
      { className: "titlebox" },
      subreddit && _react2.default.createElement(
        "h1",
        { className: "hover redditname" },
        _react2.default.createElement(
          Link,
          { className: "hover", href: "/" + siteprefix + "/" + subreddit + "/" },
          subreddit
        )
      ),
      subreddit && subreddit !== "all" && (onSubscribe || onUnsubscribe) ? _react2.default.createElement(
        "span",
        {
          className: "fancy-toggle-button subscribe-button toggle",
          "data-sr_name": subreddit,
          style: { display: "none !important" }
        },
        _react2.default.createElement(
          "a",
          {
            className: "option active remove login-required",
            tabIndex: 100,
            onClick: onUnsubscribe
          },
          "unsubscribe"
        ),
        _react2.default.createElement(
          "a",
          { className: "option add", onClick: onSubscribe },
          "subscribe"
        )
      ) : null,
      subscribers ? _react2.default.createElement(
        "span",
        { className: "subscribers" },
        _react2.default.createElement(
          "span",
          { className: "number" },
          subscribers
        ),
        " ",
        _react2.default.createElement(
          "span",
          { className: "word" },
          "readers"
        )
      ) : null,
      accounts_active && (typeof accounts_active === "undefined" ? "undefined" : _typeof(accounts_active)) !== "object" ? _react2.default.createElement(
        "p",
        {
          className: "users-online " + (accounts_active_is_fuzzed ? "fuzzed" : ""),
          title: "logged-in users viewing this subreddit in the past 15 minutes"
        },
        _react2.default.createElement(
          "span",
          { className: "number" },
          accounts_active_is_fuzzed ? "~" : "",
          accounts_active
        ),
        " ",
        _react2.default.createElement(
          "span",
          { className: "word" },
          "users here now"
        )
      ) : null,
      isShowingCustomStyleOption ? _react2.default.createElement(
        "form",
        { className: "toggle flairtoggle" },
        _react2.default.createElement("input", {
          checked: useStyle,
          onChange: useStyle ? setStyleDisabled : setStyleEnabled,
          id: "flair_enabled",
          name: "flair_enabled",
          type: "checkbox"
        }),
        _react2.default.createElement(
          "label",
          { htmlFor: "flair_enabled" },
          "Enable custom subreddit styles"
        )
      ) : null,
      _react2.default.createElement(
        "form",
        {
          action: "#",
          className: "usertext warn-on-unload",
          id: "form-t4_5rve"
        },
        _react2.default.createElement("input", { name: "thing_id", type: "hidden" }),
        (0, _util.optional)(Markdown, {
          className: "usertext-body may-blank-within md-container",
          body: description,
          html: description_html
        })
      ),
      _react2.default.createElement(
        "div",
        { className: "bottom" },
        created_by ? "created by " + created_by : null,
        " ",
        _react2.default.createElement(
          "span",
          { className: "age" },
          _react2.default.createElement(Timestamp, { created_utc: created_utc })
        )
      ),
      _react2.default.createElement("div", { className: "clear" })
    )
  );
};

exports.default = SidebarTitlebox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/SidebarTitlebox.js
// module id = 327
// module chunks = 0